/* mutation_types.js */
/** storeのstateを変更する操作は全てここに宣言された
  操作にのみよって更新される */

// プレビューボックス（ドラッグで伸縮可能な箱)の時刻を変更する
export const PREVIEWBOX_TIME_UPDATE = 'PREVIEWBOX_TIME_UPDATE'
// プレビューボックスのクラスルームを変更する
export const PREVIEWBOX_CLASSROOM_UPDATE = 'PREVIEWBOX_CLASSROOM_UPDATE'
// プレビューボックスのスタイルを変更する
export const PREVIEWBOX_STYLE_UPDATE = 'PREVIEWBOX_STYLE_UPDATE'
// 予約ポップアップを表示する
export const PREVIEWBOX_SHOW_POPUP = 'PREVIEWBOX_SHOW_POPUP'
// 予約のポップアップを非表示にする
export const PREVIEWBOX_HIDE_POPUP = 'PREVIEWBOX_HIDE_POPUP'

// 予約の編集を開始する
export const RESERVATIONBOX_ENTER_EDIT = 'RESERVATIONBOX_ENTER_EDIT'
// 編集のプレビューボックスの時刻を変更する
export const EDITINGBOX_TIME_UPDATE = 'EDITINGBOX_TIME_UPDATE'
// プレビューボックスのクラスルームを変更する
export const EDITINGBOX_CLASSROOM_UPDATE = 'EDITINGBOX_CLASSROOM_UPDATE'
// 予約のプレビューのスタイルを更新
export const EDITINGBOX_STYLE_UPDATE = 'EDITINGBOX_STYLE_UPDATE'
// 予約編集ポップアップの表示
export const EDITING_POPUP_SHOW = 'EDITING_POPUP_SHOW'
// 予約編集ポップアップの非表示
export const EDITING_POPUP_HIDE = 'EDITING_POPUP_HIDE'
// 予約編集のドラッグ開始
export const EDITINGBOX_DRAG_START = 'EDITINGBOX_DRAG_START'
// 予約編集のドラッグ終了
export const EDITINGBOX_DRAG_END = 'EDITINGBOX_DRAG_END'
// 予約の編集を完了する
export const RESERVATIONBOX_FINISH_EDIT = 'RESERVATIONBOX_FINISH_EDIT'
// 予約編集状態の更新
export const EDITINGSTATE_SET_STUDENT = 'EDITINGSTATE_SET_STUDENT'
export const EDITINGSTATE_SET_TEACHER = 'EDITINGSTATE_SET_TEACHER'
export const EDITINGSTATE_SET_MESSAGE = 'EDITINGSTATE_SET_MESSAGE'
export const EDITINGSTATE_SET_HAS_TEST = 'EDITINGSTATE_SET_HAS_TEST'
export const EDITINGSTATE_SET_TYPE = 'EDITINGSTATE_SET_TYPE'
export const EDITINGSTATE_SET_RECURRENCE = 'EDITINGSTATE_SET_RECURRENCE'
export const EDITINGSTATE_SET_IS_ONLINE = 'EDITINGSTATE_SET_IS_ONLINE'

// スマホ専用予約専用POPUPを表示
export const RESERVATION_SHOW_POPUP = 'RESERVATION_SHOW_POPUP'
// スマホ専用予約専用POPUPを非表示
export const RESERVATION_HIDE_POPUP = 'RESERVATION_HIDE_POPUP'

// 繰り返し予約のルールを更新する
export const RRULE_UPDATE = 'RRULE_UPDATE'

// 予約のリストを更新する
export const RESERVATIONS_UPDATE = 'RESERVATIONS_UPDATE'
// 現在参照している表の日付を変更する
export const TIMETABLE_CHANGE_DATE = 'TIMETABLE_CHANGE_DATE'

// ユーザー情報を更新する
export const USERINFO_UPDATE = 'USERINFO_UPDATE'
// 講義情報を更新する
export const LECTURE_UPDATE = 'LECTURE_UPDATE'
// ユーザー個別の講義情報を取得
export const USER_LECTURES_FETCH = 'USER_LECTURES_FETCH'
// ユーザー一覧を更新
export const USER_LIST_UPDATE = 'USER_LIST_UPDATE'

// 教室情報を取得
export const CLASSROOMS_FETCH = 'CLASSROOMS_FETCH'

// ログイン操作
export const LOGIN = 'LOGIN'
// ログイン完了処理
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
// ログアウト
export const LOGOUT = 'LOGOUT'

// スピナーを表示
export const SPINNER_SHOW = 'SPINNER_SHOW'
// スピナーを隠す
export const SPINNER_HIDE = 'SPINNER_HIDE'

// ヘッダの高さを更新する
export const UPDATE_HEADER_HEIGHT = 'UPDATE_HEADER_HEIGHT'

// 予約情報ポップアップの表示
export const SHOW_INFORMATION_POPUP = 'SHOW_INFORMATION_POPUP'
// 非表示
export const HIDE_INFORMATION_POPUP = 'HIDE_INFORMATION_POPUP'

// 来塾状況を更新
export const ATTENDANCE_UPDATE = 'ATTENDANCE_UPDATE'
// 1ユーザの来塾状況を変更
export const TOGGLE_USER_ATTENDANCE = 'TOGGLE_USER_ATTENDANCE'

// 授業振替情報を設定
export const SET_RESCHEDULING_INFO = 'SET_RESCHEDULING_INFO'

// 振替依頼Popup
export const RESERVATIONBOX_ENTER_RESCHEDULING = 'RESERVATIONBOX_ENTER_RESCHEDULING'
export const RESCHEDULING_POPUP_HIDE = 'RESCHEDULING_POPUP_HIDE'

export const CHANGE_SCHOOL = 'CHANGE_SCHOOL'
export const SHOW_ONLINE = 'SHOW_ONLINE'

export const MODAL = 'MODAL'



// WEBPACK FOOTER //
// ./src/vuex/mutation_types.js